import React from "react";
import { Routes, Route } from "react-router-dom";

import RouteFranqueados from "./RouteFranqueados";
import RouteTecnicos from "./RouteTecnicos";
import RoutePublic from "./RoutePublic";
import RoutePrivate from "./RoutePrivate";
import RouteHybrid from "./RouteHybrid";
import RouteAssociados from "./RouteAssociados";

import HomeFranqueados from "../pages/clientes/Home";
import Login from "../pages/public/Login";
import SolicitacoesFranqueados from "../pages/clientes/Solicitacoes";
import PerfilFranqueados from "../pages/clientes/Perfil";
import FinanceiroFranqueados from "../pages/clientes/Financeiro";
import OSFranqueados from "../pages/clientes/OS";
import OSSolicitacao from "../pages/clientes/Solicitacao";

import HomeTecnicos from "../pages/tecnicos/Home";
import SolicitacoesTecnicos from "../pages/tecnicos/Solicitacoes";
import PerfilTecnicos from "../pages/tecnicos/Perfil";
import FinanceiroTecnicos from "../pages/tecnicos/Financeiro";
import OSTecnicos from "../pages/tecnicos/OS";
import ListOSs from "../pages/tecnicos/ListOSs";

import RouteAdmin from "./RouteAdmin";
import HomeAdmin from "../pages/admin/Home";

import ServicesAdmin from "../pages/admin/Services";
import TecnicosAdmin from "../pages/admin/Tecnicos";
import FranqueadosAdmin from "../pages/admin/Franqueados";
import PerfilAdmin from "../pages/admin/Perfil";
import FinanceiroAdmin from "../pages/admin/Financeiro";
import OSDetailsAdmin from "../pages/admin/OS";
import BannersAdmin from "../pages/admin/Banners";
import CoursesAdmin from "../pages/admin/Courses";
import LessonsAdmin from "../pages/admin/Lessons";
import LessonAdmin from "../pages/admin/Lesson";
import CoursesPublic from "../pages/course/Courses";
import CoursePublic from "../pages/course/Course";
import Contracts from "../pages/contracts/Contracts";
import Contract from "../pages/contracts/Contract";
import NewContract from "../pages/contracts/NewContract";
import ResetPassword from "../pages/public/ResetPassword";
import ContractsAdmin from "../pages/contracts/ContractsAdmin";
import Credentials from "../pages/credentials/Credentials";
import NewCredential from "../pages/credentials/NewCredential";
import AdminCredentials from "../pages/credentials/AdminCredentials";
import EditCredential from "../pages/credentials/EditCredential";
import UserCredential from "../pages/credentials/UserCredential";
import Completed from "../pages/credentials/Completed";
import ServicesOS from "../pages/admin/ServicesOS";
import Company from "../pages/company/Company";
import Companies from "../pages/company/Companies";
import EditCompany from "../pages/company/EditCompany";
import CompanyRenewal from "../pages/company/CompanyRenewal";
import CompanyTimeline from "../pages/company/CompanyTimeline";
import CreateTimeline from "../pages/company/CreateTimeline";
import NewEditFranqueado from "../pages/admin/NewEditFranqueado";
import CRM from "../pages/clientes/CRM";
import RouteCRM from "./RouteCRM";
import Leads from "../pages/admin/Leads";
import AdminCRM from "../pages/admin/CRM";
import LeadsClient from "../pages/clientes/Leads";
import Lembretes from "../pages/clientes/Lembretes";
import EditContract from "../pages/contracts/EditContract";
import LeadsEnviados from "../pages/admin/LeadsEnviados";
import Comunicados from "../pages/admin/Comunicados";
import Comunicado from "../pages/admin/Comunicado";
import ComunicadosCliente from "../pages/clientes/Comunicados";
import Pagamentos from "../pages/clientes/Pagamentos";
import AdicionarSaldo from "../pages/clientes/AdicionarSaldo";
import PagamentosAdmin from "../pages/admin/Pagamentos";
import Coupon from "../pages/admin/Coupon";
import SolicitacoesAdmin from "../pages/admin/Solicitacoes";
import Certificate from "../pages/clientes/Certificate";
import ComprarLead from "../pages/clientes/CompraLead";
import PagamentoDetalhes from "../pages/clientes/PagamentoDetalhes";
import PacotesDeposito from "../pages/admin/PacotesDeposito";
import SolicitacoesUrgente from "../pages/admin/SolicitacoesUrgente";
import Depositos from "../pages/clientes/Depositos";
import DepositosAdmin from "../pages/admin/Depositos";
import ServicesCliente from "../pages/clientes/Services";
import HelpCenter from "../pages/clientes/HelpCenter";
import Atendimentos from "../pages/atendente/Home";
import RankingFranqueados from "../pages/admin/RankingFranqueados";
import Atendentes from "../pages/admin/Atendentes";
import Admins from "../pages/admin/Admins";
import PerfilAtendente from "../pages/atendente/Perfil";
import OSDetailsAttendant from "../pages/atendente/OS";
import RouteAtendente from "./RouteAtendente";
import ChamadosFranqueado from "../pages/clientes/Chamados";
import ChamadosTecnicos from "../pages/tecnicos/Chamados";
import ChamadosAdmin from "../pages/admin/Chamados";
import AssociadosAdmin from "../pages/admin/Associados";
import AssociadoDetailsAdmin from "../pages/admin/AssociadoDetails";
import AssociadosRelatorioGeral from "../pages/admin/AssociadosRelatorioGeral";
import LoginAssociado from "../pages/associado/Login";
import HomeAssociado from "../pages/associado/Home";
import LeadsAssociado from "../pages/associado/Leads";
import PerfilAssociado from "../pages/associado/Perfil";
import ComissoesAssociado from "../pages/associado/Comissoes";

const Routers = () => {
  return (
    <Routes>
      <Route exact path="/associado/login" element={<RoutePublic />}>
        <Route exact path="/associado/login" element={<LoginAssociado />} />
      </Route>
      <Route exact path="/associado/home" element={<RouteAssociados />}>
        <Route exact path="/associado/home" element={<HomeAssociado />} />
      </Route>
      <Route exact path="/associado/leads" element={<RouteAssociados />}>
        <Route exact path="/associado/leads" element={<LeadsAssociado />} />
      </Route>
      <Route exact path="/associado/comissoes" element={<RouteAssociados />}>
        <Route
          exact
          path="/associado/comissoes"
          element={<ComissoesAssociado />}
        />
      </Route>
      <Route exact path="/associado/perfil" element={<RouteAssociados />}>
        <Route exact path="/associado/perfil" element={<PerfilAssociado />} />
      </Route>
      <Route exact path="/cliente/comprar-lead" element={<RouteFranqueados />}>
        <Route exact path="/cliente/comprar-lead" element={<ComprarLead />} />
      </Route>
      <Route exact path="/cliente/depositos" element={<RouteFranqueados />}>
        <Route exact path="/cliente/depositos" element={<Depositos />} />
      </Route>
      <Route exact path="/cliente/comunicados" element={<RouteFranqueados />}>
        <Route
          exact
          path="/cliente/comunicados"
          element={<ComunicadosCliente />}
        />
      </Route>
      <Route exact path="/admin/depositos" element={<RouteAdmin />}>
        <Route exact path="/admin/depositos" element={<DepositosAdmin />} />
      </Route>
      <Route exact path="*" element={<RoutePublic />}>
        <Route exact path="*" element={<Login />} />
      </Route>
      <Route exact path="/resetpassword/:code" element={<RouteHybrid />}>
        <Route exact path="/resetpassword/:code" element={<ResetPassword />} />
      </Route>
      <Route
        exact
        path="/contract/:contract_id"
        element={<RouteHybrid sidebar={false} />}
      >
        <Route exact path="/contract/:contract_id" element={<Contract />} />
      </Route>
      <Route
        exact
        path="/company/:company_id"
        element={<RouteHybrid sidebar={false} />}
      >
        <Route exact path="/company/:company_id" element={<EditCompany />} />
      </Route>
      {/* Credentials */}
      <Route exact path="/admin/credentials" element={<RouteAdmin />}>
        <Route exact path="/admin/credentials" element={<AdminCredentials />} />
      </Route>
      <Route exact path="/admin/franqueado/:id" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/franqueado/:id"
          element={<NewEditFranqueado />}
        />
      </Route>
      <Route exact path="/admin/atendentes" element={<RouteAdmin />}>
        <Route exact path="/admin/atendentes" element={<Atendentes />} />
      </Route>
      <Route exact path="/admin/associados" element={<RouteAdmin />}>
        <Route exact path="/admin/associados" element={<AssociadosAdmin />} />
      </Route>
      <Route exact path="/admin/associados/relatorio" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/associados/relatorio"
          element={<AssociadosRelatorioGeral />}
        />
      </Route>
      <Route exact path="/admin/associado/:id" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/associado/:id"
          element={<AssociadoDetailsAdmin />}
        />
      </Route>
      <Route exact path="/admin/admins" element={<RouteAdmin />}>
        <Route exact path="/admin/admins" element={<Admins />} />
      </Route>
      <Route exact path="/admin/ranking" element={<RouteAdmin />}>
        <Route exact path="/admin/ranking" element={<RankingFranqueados />} />
      </Route>
      <Route
        exact
        path="/credential/login"
        element={<RouteHybrid sidebar={false} header={false} />}
      >
        <Route
          exact
          path="/credential/login"
          element={<Login credential={true} />}
        />
      </Route>
      <Route
        exact
        path="/credential"
        element={<RouteHybrid sidebar={false} header={false} />}
      >
        <Route exact path="/credential" element={<UserCredential />} />
      </Route>
      <Route
        exact
        path="/credentials"
        element={<RouteHybrid sidebar={false} header={false} />}
      >
        <Route exact path="/credentials" element={<Credentials />} />
      </Route>
      <Route exact path="/admin/credential/:id" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/credential/:id"
          element={<EditCredential />}
        />
      </Route>
      <Route
        exact
        path="/new-credential"
        element={<RouteHybrid sidebar={false} header={false} />}
      >
        <Route exact path="/new-credential" element={<NewCredential />} />
      </Route>
      <Route
        exact
        path="/completed/:id"
        element={<RouteHybrid sidebar={false} header={false} />}
      >
        <Route exact path="/completed/:id" element={<Completed />} />
      </Route>
      <Route
        exact
        path="/admin/new-credential"
        element={<RoutePrivate sidebar={false} header={false} />}
      >
        <Route
          exact
          path="/admin/new-credential"
          element={<NewCredential privateRoute={true} />}
        />
      </Route>
      {/* CRM */}
      <Route exact path="/crm" element={<RouteCRM />}>
        <Route exact path="/crm" element={<CRM />} />
      </Route>
      <Route exact path="/crm/:userId" element={<RouteCRM />}>
        <Route exact path="/crm/:userId" element={<AdminCRM />} />
      </Route>
      <Route exact path="/admin/leads/send" element={<RouteAdmin />}>
        <Route exact path="/admin/leads/send" element={<Leads />} />
      </Route>
      <Route exact path="/admin/leads" element={<RouteAdmin />}>
        <Route exact path="/admin/leads" element={<LeadsEnviados />} />
      </Route>
      <Route exact path="/cliente/leads" element={<RouteFranqueados />}>
        <Route exact path="/cliente/leads" element={<LeadsClient />} />
      </Route>
      <Route exact path="/cliente/reminders" element={<RouteFranqueados />}>
        <Route exact path="/cliente/reminders" element={<Lembretes />} />
      </Route>
      <Route exact path="/admin/comunicados" element={<RouteAdmin />}>
        <Route exact path="/admin/comunicados" element={<Comunicados />} />
      </Route>
      <Route exact path="/admin/comunicado/:id" element={<RouteAdmin />}>
        <Route exact path="/admin/comunicado/:id" element={<Comunicado />} />
      </Route>
      <Route exact path="/admin/pacotes" element={<RouteAdmin />}>
        <Route exact path="/admin/pacotes" element={<PacotesDeposito />} />
      </Route>
      {/* Login */}
      <Route exact path="/login" element={<RoutePublic />}>
        <Route exact path="/login" element={<Login />} />
      </Route>
      {/* Courses */}
      <Route
        exact
        path="/courses"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route exact path="/courses" element={<CoursesPublic />} />
      </Route>
      <Route
        exact
        path="/course/:course_id"
        element={
          <RoutePrivate
            sidebar={false}
            header={false}
            customContent={{ padding: 0, maxWidth: "100%" }}
          />
        }
      >
        <Route exact path="/course/:course_id" element={<CoursePublic />} />
      </Route>
      <Route
        exact
        path="/certificado"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route exact path="/certificado" element={<Certificate />} />
      </Route>
      {/* Contracts */}
      <Route
        exact
        path="/contracts"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route exact path="/contracts" element={<Contracts />} />
      </Route>
      <Route
        exact
        path="/contracts/:user_id"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route exact path="/contracts/:user_id" element={<ContractsAdmin />} />
      </Route>
      <Route
        exact
        path="/edit-contract/:contract_id"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route
          exact
          path="/edit-contract/:contract_id"
          element={<EditContract />}
        />
      </Route>
      <Route
        exact
        path="/new-contract"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route exact path="/new-contract" element={<NewContract />} />
      </Route>
      {/* Home */}
      <Route exact path="/tecnico/home" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/home" element={<HomeTecnicos />} />
      </Route>
      <Route exact path="/cliente/home" element={<RouteFranqueados />}>
        <Route exact path="/cliente/home" element={<HomeFranqueados />} />
      </Route>
      <Route exact path="/cliente/servicos" element={<RouteFranqueados />}>
        <Route exact path="/cliente/servicos" element={<ServicesCliente />} />
      </Route>
      <Route exact path="/cliente/ajuda" element={<RouteFranqueados />}>
        <Route exact path="/cliente/ajuda" element={<HelpCenter />} />
      </Route>
      <Route exact path="/admin/home" element={<RouteAdmin />}>
        <Route exact path="/admin/home" element={<HomeAdmin />} />
      </Route>
      <Route
        exact
        path="/atendente/home"
        element={
          <RouteAtendente
            sidebar={false}
            header={true}
            hiddenButtonBack={true}
            customContent={{
              paddingTop: 20,
              paddingBottom: 20,
            }}
          />
        }
      >
        <Route exact path="/atendente/home" element={<Atendimentos />} />
      </Route>

      <Route
        exact
        path="/atendente/os/:id"
        element={
          <RouteAtendente
            sidebar={false}
            header={true}
            hiddenButtonBack={true}
            customContent={{
              paddingTop: 20,
              paddingBottom: 20,
            }}
          />
        }
      >
        <Route exact path="/atendente/os/:id" element={<OSDetailsAttendant />} />
      </Route>
      <Route exact path="/tecnico/timeline" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/timeline" element={<CompanyTimeline />} />
      </Route>
      <Route exact path="/cliente/timeline" element={<RouteFranqueados />}>
        <Route exact path="/cliente/timeline" element={<CompanyTimeline />} />
      </Route>
      <Route exact path="/cliente/chamados" element={<RouteFranqueados />}>
        <Route
          exact
          path="/cliente/chamados"
          element={<ChamadosFranqueado />}
        />
      </Route>
      <Route exact path="/tecnico/chamados" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/chamados" element={<ChamadosTecnicos />} />
      </Route>
      <Route exact path="/admin/chamados" element={<RouteAdmin />}>
        <Route exact path="/admin/chamados" element={<ChamadosAdmin />} />
      </Route>
      <Route exact path="/admin/timeline" element={<RouteAdmin />}>
        <Route exact path="/admin/timeline" element={<CompanyTimeline />} />
      </Route>
      <Route exact path="/tecnico/timeline/:id" element={<RouteTecnicos />}>
        <Route
          exact
          path="/tecnico/timeline/:id"
          element={<CreateTimeline />}
        />
      </Route>
      <Route exact path="/cliente/timeline/:id" element={<RouteFranqueados />}>
        <Route
          exact
          path="/cliente/timeline/:id"
          element={<CreateTimeline />}
        />
      </Route>
      <Route exact path="/admin/timeline/:id" element={<RouteAdmin />}>
        <Route exact path="/admin/timeline/:id" element={<CreateTimeline />} />
      </Route>
      <Route exact path="/tecnico/renewal" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/renewal" element={<CompanyRenewal />} />
      </Route>
      <Route exact path="/cliente/renewal" element={<RouteFranqueados />}>
        <Route exact path="/cliente/renewal" element={<CompanyRenewal />} />
      </Route>
      <Route exact path="/admin/renewal" element={<RouteAdmin />}>
        <Route exact path="/admin/renewal" element={<CompanyRenewal />} />
      </Route>
      <Route exact path="/admin/orders" element={<RouteAdmin />}>
        <Route exact path="/admin/orders" element={<SolicitacoesAdmin />} />
      </Route>
      {/* Company */}
      <Route
        exact
        path="/companies"
        element={<RoutePrivate sidebar={true} header={true} />}
      >
        <Route exact path="/companies" element={<Companies />} />
      </Route>
      <Route
        exact
        path="/view-company/:company_id"
        element={
          <RoutePrivate
            sidebar={false}
            header={false}
            customContent={{ padding: 0, maxWidth: "100%" }}
          />
        }
      >
        <Route exact path="/view-company/:company_id" element={<Company />} />
      </Route>
      {/* OSs */}
      <Route exact path="/tecnico/os/:id" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/os/:id" element={<OSTecnicos />} />
      </Route>
      <Route
        exact
        path="/tecnico/view-company/:company_id"
        element={
          <RouteTecnicos hiddenSiderbad={true} hiddenButtonBack={true} />
        }
      >
        <Route
          path="/tecnico/view-company/:company_id"
          element={<Company />}
        />
      </Route>
      <Route exact path="/cliente/os/:id" element={<RouteFranqueados />}>
        <Route exact path="/cliente/os/:id" element={<OSFranqueados />} />
      </Route>
      <Route exact path="/solicitacao" element={<RouteFranqueados />}>
        <Route exact path="/solicitacao" element={<OSSolicitacao />} />
      </Route>
      <Route
        exact
        path="/cliente/solicitacoes"
        element={<RouteFranqueados sidebar={false} />}
      >
        <Route
          exact
          path="/cliente/solicitacoes"
          element={<SolicitacoesFranqueados />}
        />
      </Route>
      <Route exact path="/cliente/carteira" element={<RouteFranqueados />}>
        <Route exact path="/cliente/carteira" element={<Pagamentos />} />
      </Route>
      <Route exact path="/admin/orders-urgente" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/orders-urgente"
          element={<SolicitacoesUrgente />}
        />
      </Route>
      <Route exact path="/cliente/pagamento/:id" element={<RouteFranqueados />}>
        <Route
          exact
          path="/cliente/pagamento/:id"
          element={<PagamentoDetalhes />}
        />
      </Route>
      <Route
        exact
        path="/cliente/adicionar-saldo"
        element={<RouteFranqueados />}
      >
        <Route
          exact
          path="/cliente/adicionar-saldo"
          element={<AdicionarSaldo />}
        />
      </Route>
      <Route exact path="/admin/pagamentos" element={<RouteAdmin />}>
        <Route exact path="/admin/pagamentos" element={<PagamentosAdmin />} />
      </Route>
      <Route exact path="/admin/cupons" element={<RouteAdmin />}>
        <Route exact path="/admin/cupons" element={<Coupon />} />
      </Route>
      <Route exact path="/tecnico/solicitacoes" element={<RouteTecnicos />}>
        <Route
          exact
          path="/tecnico/solicitacoes"
          element={<SolicitacoesTecnicos />}
        />
      </Route>
      <Route exact path="/tecnico/open" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/open" element={<ListOSs />} />
      </Route>
      {/* Financeiro */}
      <Route exact path="/cliente/financeiro" element={<RouteFranqueados />}>
        <Route
          exact
          path="/cliente/financeiro"
          element={<FinanceiroFranqueados />}
        />
      </Route>
      <Route exact path="/tecnico/financeiro" element={<RouteTecnicos />}>
        <Route
          exact
          path="/tecnico/financeiro"
          element={<FinanceiroTecnicos />}
        />
      </Route>
      {/* Perfil */}
      <Route exact path="/tecnico/perfil" element={<RouteTecnicos />}>
        <Route exact path="/tecnico/perfil" element={<PerfilTecnicos />} />
      </Route>
      <Route exact path="/cliente/perfil" element={<RouteFranqueados />}>
        <Route exact path="/cliente/perfil" element={<PerfilFranqueados />} />
      </Route>
      <Route exact path="/admin/perfil" element={<RouteAdmin />}>
        <Route exact path="/admin/perfil" element={<PerfilAdmin />} />
      </Route>
      <Route
        exact
        path="/atendente/perfil"
        element={
          <RoutePrivate sidebar={false} header={true} hiddenButtonBack={true} />
        }
      >
        <Route exact path="/atendente/perfil" element={<PerfilAtendente />} />
      </Route>
      {/* Admin */}
      <Route exact path="/admin/services" element={<RouteAdmin />}>
        <Route exact path="/admin/services" element={<ServicesAdmin />} />
      </Route>
      <Route exact path="/admin/banners" element={<RouteAdmin />}>
        <Route exact path="/admin/banners" element={<BannersAdmin />} />
      </Route>
      <Route exact path="/admin/courses" element={<RouteAdmin />}>
        <Route exact path="/admin/courses" element={<CoursesAdmin />} />
      </Route>
      <Route exact path="/admin/lessons/:course_id" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/lessons/:course_id"
          element={<LessonsAdmin />}
        />
      </Route>
      <Route exact path="/admin/services-os/:id" element={<RouteAdmin />}>
        <Route exact path="/admin/services-os/:id" element={<ServicesOS />} />
      </Route>
      <Route exact path="/admin/lesson/:course_id/:id" element={<RouteAdmin />}>
        <Route
          exact
          path="/admin/lesson/:course_id/:id"
          element={<LessonAdmin />}
        />
      </Route>
      <Route exact path="/admin/tecnicos" element={<RouteAdmin />}>
        <Route exact path="/admin/tecnicos" element={<TecnicosAdmin />} />
      </Route>
      <Route exact path="/admin/clientes" element={<RouteAdmin />}>
        <Route exact path="/admin/clientes" element={<FranqueadosAdmin />} />
      </Route>
      <Route
        exact
        path="/admin/financeiro-cliente/:id"
        element={<RouteAdmin />}
      >
        <Route
          exact
          path="/admin/financeiro-cliente/:id"
          element={<FinanceiroAdmin type={"user"} />}
        />
      </Route>
      <Route
        exact
        path="/admin/financeiro-tecnico/:id"
        element={<RouteAdmin />}
      >
        <Route
          exact
          path="/admin/financeiro-tecnico/:id"
          element={<FinanceiroAdmin type={"collaborator"} />}
        />
      </Route>
      <Route exact path="/admin/os/:id" element={<RouteAdmin />}>
        <Route exact path="/admin/os/:id" element={<OSDetailsAdmin />} />
      </Route>
    </Routes>
  );
};

export default Routers;
